export const ChartIcon = () => (
  <svg
    className="nav-item-icon"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path>
    <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path>
  </svg>
);

export const PersonIcon = () => (
  <svg
    className="nav-item-icon"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z"
      clipRule="evenodd"
      fillRule="evenodd"
    ></path>
  </svg>
);

export const SmileyIcon = () => (
  <svg
    className="nav-item-icon"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      d="M10 18a8 8 0 100-16 8 8 0 000 16zM7 9a1 1 0 100-2 1 1 0 000 2zm7-1a1 1 0 11-2 0 1 1 0 012 0zm-.464 5.535a1 1 0 10-1.415-1.414 3 3 0 01-4.242 0 1 1 0 00-1.415 1.414 5 5 0 007.072 0z"
      clipRule="evenodd"
      fillRule="evenodd"
    ></path>
  </svg>
);

export const InfoIcon = () => (
  <svg
    className="nav-item-icon"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      fillRule="evenodd"
      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const DownloadIcon = () => (
  <svg
    className="nav-item-icon"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 20 20"
  >
    <path
      fillRule="evenodd"
      d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm3.293-7.707a1 1 0 011.414 0L9 10.586V3a1 1 0 112 0v7.586l1.293-1.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export const SpamIcon = () => (
  <svg
    className="nav-item-icon"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M12 2L4 5v6c0 5.55 3.84 10.74 8 12 4.16-1.26 8-6.45 8-12V5l-8-3zm-1 13l-3-3 1.41-1.41L11 12.17l4.59-4.59L17 9l-6 6z" />
  </svg>
);

export const MeetingIcon = () => (
  <svg
    className="nav-item-icon"
    width="20"
    height="20"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path d="M19 3h-1V1h-2v2H8V1H6v2H5a2 2 0 00-2 2v14a2 2 0 002 2h7v-2H5V9h14v1.26c.71.39 1.37.9 2 1.51V5a2 2 0 00-2-2zM5 7V5h14v2H5zm14.5 5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zm.5 3h-2v3.25l2.25 1.35.75-1.23-1.5-.87V15z" />
  </svg>
);